import { createContext, useContext, type ReactNode } from "react";
import { useMonAbonnement, type UseMonAbonnementValue } from "@/store/platform/useMonAbonnement";

type AbonnementContextValue = UseMonAbonnementValue;

const AbonnementContext = createContext<AbonnementContextValue | null>(null);

/**
 * Abonnement de l'espace Propriétaire.
 *
 * La source de vérité est Supabase : l'abonnement réel du compte est lu via la
 * RPC `abonnement_du_compte()` et enregistré via `choisir_formule()` /
 * `renouveler_abonnement()`. Les limites et l'expiration sont appliquées côté
 * serveur (RPC + triggers) : le frontend ne fait que refléter l'état réel.
 */
export function AbonnementProvider({ children }: { children: ReactNode }) {
  const value = useMonAbonnement();
  return <AbonnementContext.Provider value={value}>{children}</AbonnementContext.Provider>;
}

export function useAbonnement(): AbonnementContextValue {
  const context = useContext(AbonnementContext);
  if (!context) {
    throw new Error("useAbonnement doit être utilisé à l'intérieur de AbonnementProvider");
  }
  return context;
}